// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"37a0e784","346":"b0e924b9","776":"7fc8f61c","785":"5c4fd426"}[chunkId] + ".chunk.js";
};